export const environment = {
    production: true,
    urls: {
        core: 'https://api.improvation.us/core',
    }
};
